export default "__VITE_ASSET__BpmSuS1g__"